import { request } from '@/apis/request';
// 百源-数据权限 - 1、获取当前用户角色关联的数据组列表
export const fetchRoleRelationList = async (roleId: string) => {
  const res: any = await request({
    method: 'get',
    url: `/dev-basp-data-auth/data-groups/role/${roleId}`,
  });
  const { result = [] } = res;
  return result;
};

// 百源-数据权限 - 2、获取数据组绑定的主数据列表
export const fetchDataBindList = async (dataGroupId: string) => {
  const res: any = await request({
    method: 'get',
    url: `/dev-basp-data-auth/data-groups/${dataGroupId}/master-data`,
  });
  const { result = [] } = res;
  return result;
};
